import { autoinject } from "aurelia-framework";
import { transient } from "aurelia-dependency-injection";

@autoinject
@transient()
export class RightShipNotAuthorized {
    
    constructor() { }

    tryagain() {
        return window.location.href ="";  
    }
}